









































































































































































































































































































































































































































































































import { openOttoPay } from '@/utils/ottoPay'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import PosOrderModal from '@/components/PosOrderModal.vue'
import {
  formatNumber,
  getRequestId,
  formatCouponText,
  getEdcMidMapping,
  isMobile
} from '@/utils/helpers'
import { cloneDeep, debounce, take, uniq } from 'lodash-es'
import api from '@/api'
import constants from '@/utils/constants'
import countryData from '@/utils/country'
import CouponModal from '@/components/CouponModal/CouponModal.vue'
import CurrencyInput from '@/components/CurrencyInput.vue'
import CountrySelector from '@/components/CountrySelector/CountrySelector.vue'
import './style.scss'

const VUE_APP_OTTOPAY =
  typeof process.env.VUE_APP_OTTOPAY === 'string'
    ? JSON.parse(process.env.VUE_APP_OTTOPAY || '[]')
    : process.env.VUE_APP_OTTOPAY

const VUE_APP_DEBIT_AND_CREDIT =
  typeof process.env.VUE_APP_DEBIT_AND_CREDIT === 'string'
    ? JSON.parse(process.env.VUE_APP_DEBIT_AND_CREDIT || '[]')
    : process.env.VUE_APP_DEBIT_AND_CREDIT
@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    }
  },
  components: {
    CouponModal,
    CurrencyInput,
    CountrySelector,
    PosOrderModal
  }
})
export default class CartList extends Vue {
  @Prop() showCart!: boolean
  @Prop() cartList!: Array<any>
  @Prop(Function) minusItem!: Function
  @Prop(Function) plusItem!: Function
  @Prop(Function) deleteItem!: Function
  @Prop(Function) showVariantsHandle!: Function
  @Prop(Function) hideCartHandle!: Function
  @Prop(Function) updateCartList!: Function
  @Prop(Function) changeNote!: Function
  @Prop(Function) clearCartList!: Function
  public country: any = countryData[0]
  public payment: string = 'QRPay'
  public customerName: string = ''
  public phoneNumber: string = ''
  public showDetail: boolean = false
  public notes: string = ''
  public orderType: string = ''
  public has_service_fee: number = 0
  public has_tax: number = 1
  public promo_value: number = 0
  public free_promo_value: number = 0
  public promo_type: number = 1
  public discount_name: string = ''
  public paymentDetail: any = {}
  public building_name: string = ''
  public room_no: string = ''
  public has_processing_fee: number = 1
  public validPhone: boolean = true
  public isPostPay: boolean = false
  public showPaymentChannel: boolean = false
  public showDiscountChannel: boolean = false
  public fetchingCoupons: boolean = false
  public coupon: any = {}
  public showCouponModal: boolean = false
  public coupons: Array<any> = []
  public formatCouponText: Function = formatCouponText
  public fetchingOrder: boolean = false
  public options: Array<any> = [
    {
      value: 'QRPay',
      text: 'QRIS - CIMB',
      shortValue: 'QR',
      type: 'online'
    },
    {
      value: 'Qris-GoPay',
      text: 'QRIS - Gopay',
      shortValue: 'MQ',
      type: 'online'
    },
    {
      value: 'Qris-ShopeePay',
      text: 'QRIS - Shopee pay',
      shortValue: 'MQ',
      type: 'online'
    },
    {
      value: 'Astrapay',
      text: 'QRIS - AstraPay',
      shortValue: 'ASTRA',
      type: 'online'
    },
    {
      value: 'QR', // for ottopay
      text: 'EDC - QRIS Payment',
      shortValue: 'OQ',
      type: 'online'
    },
    {
      value: 'DEBITCARD', // for ottopay
      text: 'EDC - Debit Card',
      shortValue: 'CD',
      type: 'online'
    },
    {
      value: 'CREDITCARD', // for ottopay
      text: 'EDC - Credit Card',
      shortValue: 'CD',
      type: 'online'
    },
    {
      value: 'DEBITCARD',
      text: 'Debit Card',
      shortValue: 'DE',
      type: 'online'
    },
    {
      value: 'CREDITCARD',
      text: 'Credit Card',
      shortValue: 'CR',
      type: 'online'
    },
    {
      value: 'Pay At Hotel',
      text: 'Pay At Hotel',
      shortValue: 'HO',
      type: 'online'
    },
    {
      value: 'Cash',
      text: 'Cash',
      shortValue: 'OFFLINE',
      type: 'offline'
    },
    {
      value: 'CIMB QR Static',
      text: 'CIMB QR Static',
      shortValue: 'OFFLINE',
      type: 'offline'
    },
    {
      value: 'QR - BCA',
      text: 'QR - BCA',
      shortValue: 'OFFLINE',
      type: 'offline'
    },
    {
      value: 'Voucher Event',
      text: 'Voucher Event',
      shortValue: 'OFFLINE',
      type: 'offline'
    },
    {
      value: 'Voucher ASRI',
      text: 'Voucher ASRI',
      shortValue: 'OFFLINE',
      type: 'offline'
    },
    {
      value: 'Debit BCA',
      text: 'Debit BCA',
      shortValue: 'OFFLINE',
      type: 'offline'
    },
    {
      value: 'Debit Mandiri',
      text: 'Debit Mandiri',
      shortValue: 'OFFLINE',
      type: 'offline'
    }
  ]
  public onlineOptions: Array<any> = []
  public offlineOptions: Array<any> = []
  public discountOptions: Array<any> = [
    { value: 0.00001, text: 'Full Amount', disabled: false },
    { value: 10000, text: 'Rp. 10.000', disabled: false },
    { value: 30000, text: 'Rp. 30.000', disabled: false },
    { value: 50000, text: 'Rp. 50.000', disabled: false },
    { value: 75000, text: 'Rp. 75.000', disabled: false },
    { value: 100000, text: 'Rp. 100.000', disabled: false },
    { value: 150000, text: 'Rp. 150.000', disabled: false },
    { value: 200000, text: 'Rp. 200.000', disabled: false },
    { value: 250000, text: 'Rp. 250.000', disabled: false }
  ]
  public selectedPayment: object = {}
  public orderLines: Array<any> = []
  public countSubtotal: number = 0
  public submitLoading: boolean = false
  public orderRequestId: string = ''
  public debounceCalculate
  public hasDiscount: boolean = false
  public shortOrderType: string = ''
  public custom_total_payment: number = 0
  public isRamdanOutlet: boolean = false
  public constants: any = constants
  public outletData: any = {}
  public showCashStep: boolean = false
  public cashOption = [
    { value: 'all', text: 'Exact Cash' },
    { value: 'other', text: 'Others Amount' },
    { value: '10000', text: 'Rp. 10.000' },
    { value: '20000', text: 'Rp. 20.000' },
    { value: '50000', text: 'Rp. 50.000' },
    { value: '100000', text: 'Rp. 100.000' }
  ]
  public cashType: string = ''
  public cashAmount: number = 0
  public cashAmountInput: number = 0
  public showCashModal: boolean = false
  public showPosOrderPopup: boolean = false
  public posOrderId: string = ''
  $swal: any
  setCountry(item) {
    this.country = item
  }
  get isOfflinePayment() {
    return (
      this.offlineOptions.findIndex(item => item.value === this.payment) !== -1
    )
  }
  get limitCoupon() {
    return (
      this.orderType === constants.PPDI || this.orderType === constants.PPTA
    )
  }
  get disableCoupon() {
    return this.limitCoupon && (!this.validPhone || !this.phoneNumber)
  }
  get showCouponAlert() {
    return this.disableCoupon && this.promo_type === 2
  }
  get canSubmit() {
    return (
      this.cartList.length &&
      this.validPhone &&
      ((this.isRamdanOutlet && this.custom_total_payment) ||
        !this.isRamdanOutlet) &&
      !this.submitLoading &&
      !this.fetchingOrder &&
      this.payment &&
      ((this.showCashStep &&
        this.cashAmount >= this.paymentDetail.totalSales) ||
        !this.showCashStep)
    )
  }
  handleClose() {
    if (this.showCashStep) {
      this.showCashStep = false
    } else {
      this.hideCartHandle()
    }
  }
  formatPrice(val: any) {
    let date: any = val
    return formatNumber(date)
  }
  showDetailHandle() {
    this.showDetail = !this.showDetail
  }
  @Watch('phoneNumber')
  watchPhoneNumber() {
    if (this.limitCoupon && this.coupon.id) {
      this.coupon = {}
      if (this.promo_type === 2) {
        this.debounceCalculate()
      }
    }
    if (!this.phoneNumber) return (this.validPhone = true)
    if (
      this.country.code === '+62' &&
      (this.phoneNumber.length > 15 ||
        this.phoneNumber.length < 9 ||
        (this.phoneNumber &&
          (take(this.phoneNumber, 2).join('') !== '08' &&
            this.phoneNumber[0] !== '8')))
    ) {
      this.validPhone = false
    } else {
      this.validPhone = true
    }
  }
  @Watch('country.code')
  watchCountry() {
    this.watchPhoneNumber()
  }
  @Watch('cartList')
  watchCartList() {
    this.debounceCalculate()
  }
  @Watch('promo_type')
  watchPromoType() {
    this.promo_value = 0
    this.free_promo_value = 0
    this.coupon = {}
    if (this.payment === 'Voucher ASRI') {
      this.payment = this.options[0] ? this.options[0].value : ''
    }
    this.debounceCalculate()
  }

  @Watch('has_processing_fee')
  watchHasProcessingFee() {
    this.debounceCalculate()
  }

  @Watch('has_service_fee')
  watchServiceFee() {
    this.debounceCalculate()
  }
  @Watch('has_tax')
  watchTax() {
    this.debounceCalculate()
  }
  @Watch('outletData.payment_method')
  watchPaymentMethod() {
    if (this.outletData.payment_method === 'Astrapay' && this.orderType !== constants.OTHERS) {
      this.payment = 'Astrapay';
    }
  }
  showPaymentChannelHandle() {
    this.showPaymentChannel = true
  }
  hidePaymentChannelHandle() {
    this.showPaymentChannel = false
  }
  showDiscountChannelHandle() {
    this.showDiscountChannel = true
  }
  hideDiscountChannelHandle() {
    this.showDiscountChannel = false
  }
  async getCoupons() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    this.fetchingCoupons = true
    const phone = this.limitCoupon
      ? `${this.country.code}-${this.phoneNumber}`
      : undefined
    api
      .GetStoreCoupons(posOrderOutlet.value, this.orderType, phone)
      .then((res: any) => {
        if (res.data && res.data.status === 200) {
          this.coupons = res.data.result
        } else {
          this.coupons = []
        }
      })
      .catch(() => {
        this.coupons = []
      })
      .finally(() => {
        this.fetchingCoupons = false
      })
  }
  showCouponModalHandle() {
    this.showCouponModal = true
    if (this.coupons.length === 0 || this.limitCoupon) {
      this.getCoupons()
    }
  }
  setCouponHandle(item) {
    this.showCouponModal = false
    if (item.id === this.coupon.id) {
      this.coupon = item
      return
    }
    this.coupon = item
    this.debounceCalculate()
  }
  hideCouponHandle() {
    this.showCouponModal = false
  }
  changePayment(e) {
    this.selectedPayment = this.options.filter(item => item.value === e)[0]
    this.payment = e
    this.hidePaymentChannelHandle()
  }
  showCash() {
    this.cashType = ''
    this.cashAmount = 0
    this.showCashStep = true
  }
  changeCashAmount() {
    this.cashAmount = this.cashAmountInput
    this.showCashModal = false
  }
  changeCashAmountInput(e) {
    this.cashAmountInput = e
  }
  changeCashType(v) {
    if (this.cashType !== v) {
      this.cashAmountInput = 0
    }
    switch (v) {
      case 'all':
        this.cashAmount = this.paymentDetail.totalSales
        break
      case 'other':
        if (this.cashType !== v) {
          this.cashAmount = 0
        }
        this.showCashModal = true
        break
      default:
        this.cashAmount = Number(v)
    }
    this.cashType = v
  }
  async calculateOrder() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    let passSelectPaymentAuto = true
    if (this.outletData.is_pos_input && this.outletData.is_pos_input !== 0) {
      if (this.options.length !== 1) {
        passSelectPaymentAuto = false
      }
    }

    const MerchantName = localStorage.getItem('UserName')
    if (!this.cartList.length) {
      this.paymentDetail = {}
      return
    }
    const orderLines: Array<any> = []
    let countSubtotal = 0
    for (let i = 0; i < this.cartList.length; i++) {
      const item = this.cartList[i]
      countSubtotal += item.price * item.num
      let variants: Array<any> = []
      if (item.variants && item.variants.length) {
        for (let j = 0; j < item.variants.length; j++) {
          const variant = item.variants[j]
          let variant_detail_id: Array<any> = []
          for (let k = 0; k < variant.variant_items.length; k++) {
            const variantItem = variant.variant_items[k]
            if (variantItem.checked) {
              countSubtotal += variantItem.value * item.num
              variant_detail_id.push(variantItem.id)
            }
          }
          variants.push({ variant_id: variant.id, variant_detail_id })
        }
        orderLines.push({
          menuGroupCode: item.menuGroupCode,
          menuItemCode: item.menuItemCode,
          quantity: item.num,
          variants,
          setItems: [],
          note: item.note
        })
      } else {
        orderLines.push({
          menuGroupCode: item.menuGroupCode,
          menuItemCode: item.menuItemCode,
          quantity: item.num,
          variants: [],
          setItems: [],
          note: item.note
        })
      }
    }
    this.countSubtotal = countSubtotal

    if (!passSelectPaymentAuto) {
      for (let i = 0; i < this.discountOptions.length; i++) {
        const element = this.discountOptions[i]
        // if (i) {
        if (element.value > countSubtotal) {
          element.disabled = true
        } else {
          element.disabled = false
        }
        // }
      }
    } else {
      for (let i = 0; i < this.discountOptions.length; i++) {
        const element = this.discountOptions[i]
        if (element.value > countSubtotal) {
          element.disabled = true
        } else {
          element.disabled = false
        }
      }
    }

    this.orderLines = orderLines
    if (this.promo_type === 1 && this.promo_value && !passSelectPaymentAuto) {
      let method = ''
      if (countSubtotal <= this.promo_value) {
        method = 'Voucher ASRI'
      } else {
        method = ''
      }
      if (this.promo_value === 0.00001) {
        method = 'Voucher ASRI'
      }
      if (method) {
        this.selectedPayment = this.options.filter(
          item => item.value === method
        )[0]
        this.payment = method
      }
    }

    this.fetchingOrder = true
    this.showDetail = false

    api
      .BoCalCulateOrder({
        orderType: this.orderType,
        orderSource: 'BO',
        destinationStore: { outletCode: String(posOrderOutlet.value) },
        orderLines,
        custom_total_payment: Number(this.custom_total_payment || 0),
        requestId: getRequestId(),
        promo_value:
          this.promo_type !== 2
            ? Number(
                this.promo_value === 0.00001
                  ? countSubtotal
                  : this.free_promo_value || this.promo_value
              )
            : undefined,
        discount_name: this.promo_type !== 2 ? this.discount_name : undefined,
        promo_type: this.promo_type,
        promo_id: this.promo_type === 2 ? this.coupon.id : undefined,
        promo_ids:
          this.promo_type === 2 && this.coupon.id
            ? [this.coupon.id]
            : undefined,
        referral_type:
          this.promo_type === 2 ? this.coupon.referral_type : undefined,
        referral_user_type:
          this.promo_type === 2 ? this.coupon.referral_user_type : undefined,
        has_service_fee: this.has_service_fee,
        has_tax: this.has_tax,
        user: {
          qravedUserID: constants.DEFAULT_USER_ID,
          name: this.customerName || MerchantName,
          phoneNo: this.country.code + '-' + (this.phoneNumber || '0888888888'),
          id: constants.DEFAULT_USER_ID
        },
        building_name: sessionStorage.getItem('building_name'),
        has_processing_fee: this.has_processing_fee
      })
      .then(res => {
        const message = (res.data as any).invalidMessage
        if (message !== constants.UPPER_SUCCESS) {
          this.$swal(
            constants.SOMETHING_WROING,
            message,
            constants.STATUS_ERROR
          )
          this.fetchingOrder = false
          this.coupon = {}
          return
        }
        try {
          this.fetchingOrder = false
          const { couponUseResult, orderCalculations } = res.data.data
          if (couponUseResult !== constants.STATUS_SUCCESS) {
            this.$swal(
              constants.SOMETHING_WROING,
              couponUseResult,
              constants.STATUS_ERROR
            )
            this.coupon = {}
          }
          const paymentDetail = {}
          for (let i = 0; i < orderCalculations.length; i++) {
            const element = orderCalculations[i]
            paymentDetail[element.key] = element.value
          }
          this.paymentDetail = paymentDetail
        } catch (error) {
          // throw error;
        }
      })
  }
  filterPaymentMethod() {
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    const VUE_APP_OFFLINE_PAYMENT = JSON.parse(
      process.env.VUE_APP_OFFLINE_PAYMENT || '[]'
    )
    const VUE_APP_RAMADAN_OUTLETS = JSON.parse(
      process.env.VUE_APP_RAMADAN_OUTLETS || '[]'
    )
    let hasOtto = false
    let hasDebitAndCredit = false
    VUE_APP_OTTOPAY.map(key => {
      if (Number(key) === Number(posOrderOutlet.value)) {
        hasOtto = true
      }
    })
    VUE_APP_DEBIT_AND_CREDIT.map(key => {
      if (Number(key) === Number(posOrderOutlet.value)) {
        hasDebitAndCredit = true
      }
    })

    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    if (
      this.outletData.payment_order === 'post_pay' &&
      (this.orderType === constants.TOP || this.orderType === constants.ROOM)
    ) {
      this.isPostPay = true
    }

    if (this.outletData.is_pos_input && this.outletData.is_pos_input !== 0) {
      this.hasDiscount = true
    }
    if (VUE_APP_RAMADAN_OUTLETS.includes(String(posOrderOutlet.value))) {
      this.hasDiscount = false
      this.isRamdanOutlet = true
    }
    if (this.orderType === constants.OTHERS) {
      this.options = VUE_APP_OFFLINE_PAYMENT.map(item => {
        if (item !== 'Shopeefood' && item !== 'Gojek') {
          return { value: item, text: item, shortValue: item }
        } else {
          return {}
        }
      }).filter(item => item.value)
      this.payment = ''
      this.selectedPayment = {}
      return
    }
    let filterByPaymentMethod =
      this.orderType === constants.TOP ? 'CA,CD,OQ' : 'CD,OQ'
    if (this.outletData.is_pos_input && this.outletData.is_pos_input !== 0) {
      const qrPaymentMethod =
        this.outletData.payment_method === 'Midtrans' ? 'MQ' : 'QR'
      const astraPaymentMethod = this.outletData.bo_astrapay_payment
        ? 'ASTRA,'
        : ''
      filterByPaymentMethod =
        this.orderType === constants.TOP
          ? qrPaymentMethod + astraPaymentMethod + ',CA'
          : qrPaymentMethod +
            astraPaymentMethod +
            (hasOtto ? ',CD,OQ' : hasDebitAndCredit ? ',DE,CR' : '')
    }
    const offlinePaymentMethod =
      this.outletData.bo_offline_payment &&
      (this.orderType === constants.PPDI || this.orderType === constants.PPTA)
        ? ',OFFLINE'
        : ''
    filterByPaymentMethod = filterByPaymentMethod + offlinePaymentMethod

    if (this.orderType === constants.ROOM) {
      filterByPaymentMethod = ',HO'
    }

    const filteredOptions: Array<any> = []
    filteredOptions.push(
      ...this.options.filter(item => {
        return filterByPaymentMethod.includes(item.shortValue)
      })
    )

    this.options = uniq(filteredOptions)
    console.log(this.outletData.payment_method)

    this.onlineOptions = this.options
      .filter(item => item.type === 'online')
      .filter(
        item =>
          this.outletData.payment_method === 'Astrapay'
            ? item.shortValue !== 'QR'
            : item.shortValue !== 'ASTRA'
      )
    this.offlineOptions = this.options.filter(item => item.type === 'offline')
    this.payment = this.options[0] ? this.options[0].value : ''
    this.selectedPayment = this.options[0]
  }
  promoValueFocus() {
    if (isMobile()) {
      ;(this.$refs as any).discountChannel.style =
        'transform: translate(-50%, 0) scale(1.3); top: unset; bottom: 55px;'
    }
  }
  promoValueBlur() {
    if (isMobile()) {
      ;(this.$refs as any).discountChannel.style = ''
    }
  }
  intoView(e) {
    if (e && e.srcElement) {
      setTimeout(() => {
        e.srcElement.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        })
      }, 500)
    }
  }
  mounted() {
    const sessionOrderType: string =
      sessionStorage.getItem('order_type') || '{}'
    this.outletData = JSON.parse(localStorage.getItem('outletData') || '{}')

    this.shortOrderType = sessionOrderType
    switch (sessionOrderType) {
      case 'table-order':
        this.orderType = constants.TOP
        break
      case 'dine-in':
        this.orderType = constants.PPDI
        break
      case 'take-away':
        this.orderType = constants.PPTA
        break
      case 'delivery':
        this.orderType = constants.HMD
        break
      case 'room':
        this.orderType = constants.ROOM
        break
      default:
        this.orderType = constants.OTHERS
        break
    }
    if (this.orderType === constants.TOP) {
      this.has_service_fee = 1
    }
    if (this.orderType !== constants.OTHERS) {
      this.discountOptions.shift()
    }

    this.filterPaymentMethod()

    const sessionCartListInfo = sessionStorage.getItem('cartListInfo')
    if (sessionCartListInfo) {
      const {
        free_promo_value,
        promo_value,
        discount_name,
        promo_type,
        coupon,
        payment,
        phoneNumber,
        country,
        customerName,
        notes,
        has_service_fee,
        has_tax,
        room_no
      } = JSON.parse(sessionCartListInfo)
      this.free_promo_value = Number(free_promo_value) || 0
      this.promo_value = Number(promo_value)
      this.promo_type = promo_type || 1
      this.coupon = coupon
      this.has_service_fee = has_service_fee || 0
      this.has_tax = has_tax || 0
      this.payment = payment
      this.room_no = room_no
      if (!this.phoneNumber) {
        this.phoneNumber = phoneNumber
      }
      this.country = country
      if (!this.customerName) {
        this.customerName = customerName
      }
      if (!this.notes) {
        this.notes = notes
      }
      if (!this.discount_name) {
        this.discount_name = discount_name
      }
    }
    if (this.cartList.length) {
      this.debounceCalculate()
    }
  }
  submitHandle() {
    if (this.submitLoading) {
      return
    }
    sessionStorage.removeItem('isPos')
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}');
    const posOrderOutlet = JSON.parse(
      localStorage.getItem('pos-order-outlet') || '{}'
    )
    const MerchantName = localStorage.getItem('UserName')
    sessionStorage.setItem(
      'cartListInfo',
      JSON.stringify({
        cartList: this.cartList,
        free_promo_value: this.free_promo_value,
        promo_value: this.promo_value,
        discount_name: this.discount_name,
        promo_type: this.promo_type,
        coupon: this.coupon,
        has_service_fee: this.has_service_fee,
        has_tax: this.has_tax,
        payment_method: this.outletData.payment_method,
        payment: this.payment,
        phoneNumber: this.phoneNumber,
        country: this.country,
        customerName: this.customerName,
        totalSales: (this.paymentDetail as any).totalSales,
        notes: this.notes,
        selectedPayment: this.selectedPayment,
        room_no: this.room_no,
        cashAmount: Number(this.cashAmount || 0),
        posOrderInput: {
          active: outletData.pos_active,
          posName: outletData.pos_name,
          mandatory: outletData.pos_order_required
        }
      })
    )
    if (
      this.promo_type !== 2 &&
      ((this.promo_value && !this.discount_name) ||
        (this.free_promo_value && !this.discount_name))
    ) {
      return this.$swal(
        constants.SOMETHING_WROING,
        'The Discount Name is required',
        constants.STATUS_ERROR
      )
    }
    this.submitLoading = true
    const orderPayload: any = {
      userId: constants.DEFAULT_USER_ID,
      orderType: this.orderType,
      orderSource: 'BO',
      TableNo: sessionStorage.getItem('table_no'),
      building_name: sessionStorage.getItem('building_name'),
      room_no: this.room_no,
      promo_value:
        this.promo_type !== 2
          ? Number(
              this.promo_value === 0.00001
                ? this.countSubtotal
                : this.free_promo_value || this.promo_value
            )
          : undefined,
      discount_name: this.promo_type !== 2 ? this.discount_name : undefined,
      promo_type: this.promo_type,
      promo_id: this.promo_type === 2 ? this.coupon.id : undefined,
      promo_ids:
        this.promo_type === 2 && this.coupon.id ? [this.coupon.id] : undefined,
      referral_code:
        this.promo_type === 2 ? this.coupon.referral_code : undefined,
      referral_type:
        this.promo_type === 2 ? this.coupon.referral_type : undefined,
      referral_user_type:
        this.promo_type === 2 ? this.coupon.referral_user_type : undefined,
      commission: this.promo_type === 2 ? this.coupon.commission : undefined,
      referral_campaign_id:
        this.promo_type === 2 ? this.coupon.referral_campaign_id : undefined,
      has_service_fee: this.has_service_fee,
      has_tax: this.has_tax,
      custom_total_payment: Number(this.custom_total_payment || 0),
      payment: [
        {
          paymentAmount: (this.paymentDetail as any).totalSales,
          paymentUsed: (this.paymentDetail as any).totalSales,
          paymentMethodCode: this.payment.replace(' ', '')
        }
      ],
      destinationStore: { outletCode: String(posOrderOutlet.value) },
      orderLines: this.orderLines,
      requestId: this.orderRequestId || (this.orderRequestId = getRequestId()),
      user: {
        qravedUserID: constants.DEFAULT_USER_ID,
        name: this.customerName || MerchantName,
        phoneNo: this.country.code + '-' + (this.phoneNumber || '0888888888'),
        id: constants.DEFAULT_USER_ID
      },
      posOrderId: this.posOrderId || undefined,
      notes: this.notes,
      contact: {
        phone: this.country.code + '-' + (this.phoneNumber || '0888888888'),
        name: this.customerName || MerchantName
      },
      has_processing_fee: this.has_processing_fee,
      cash_amount:
        this.payment === 'Cash' && this.cashAmount
          ? Number(this.cashAmount)
          : undefined
    }
    if (this.orderType === constants.OTHERS) {
      api.BoConsultOtherOrder(orderPayload).then(res => {
        const message = (res.data as any).invalidMessage
        this.submitLoading = false
        if (message !== constants.UPPER_SUCCESS) {
          this.$swal(
            constants.SOMETHING_WROING,
            message,
            constants.STATUS_ERROR
          )
          return
        }
        if (openOttoPay(this, res.data.data, { cartList: this.cartList || [] })) return
        this.$swal(
          constants.SUCCESS_MESSAGE,
          'Your order has been created.',
          constants.STATUS_SUCCESS
        )
        this.orderRequestId = ''
        this.clearCartList()
        this.$router.push(`/order-report`)
      })
      return
    }

    if (this.isPostPay) {
      orderPayload.payment[0].paymentMethodCode = ''
      api.BoPostPayOrder(orderPayload).then(res => {
        sessionStorage.removeItem('leftTime')
        const message = (res.data as any).invalidMessage
        this.submitLoading = false
        if (message !== constants.UPPER_SUCCESS) {
          this.$swal(
            constants.SOMETHING_WROING,
            message,
            constants.STATUS_ERROR
          )
          return
        }
        this.$swal(
          constants.SUCCESS_MESSAGE,
          'Your order has been created.',
          constants.STATUS_SUCCESS
        )
        this.orderRequestId = ''
        this.clearCartList()
        this.$router.push(`/order-report`)
      })
      return
    }
    api.BoConsultOrder(orderPayload).then(res => {
      sessionStorage.removeItem('leftTime')
      const message = (res.data as any).invalidMessage
      this.submitLoading = false
      if (message !== constants.UPPER_SUCCESS) {
        this.orderRequestId = ''
        this.$swal(constants.SOMETHING_WROING, message, constants.STATUS_ERROR)
        return
      }
      const data = res.data.data
        if (openOttoPay(this, data, { cartList: this.cartList || [] })) return

      if (data.paymentSuccess) {
        this.orderRequestId = ''
        sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
        sessionStorage.setItem(
          'cartListInfo',
          JSON.stringify({
            isFree: true,
            selectedPayment: {
              text: 'Free'
            },
            posOrderInput: {
              active: outletData.pos_active,
              posName: outletData.pos_name,
              mandatory: outletData.pos_order_required
            }
          })
        )

        sessionStorage.setItem('orderId', data.orderId)
        this.$router.push('/pos-result')
        return
      }

      if (this.isOfflinePayment) {
        if (!this.outletData.bo_offline_payment) {
          return
        }
        if (this.payment === 'Cash') {
          this.orderRequestId = ''
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          this.$router.push('/pos-result')
          return
        }
        this.orderRequestId = ''
        this.clearCartList()
        this.$router.push(`/order-report`)
        return
      }

      if (!constants.QR_TYPE.includes(this.payment)) {
        if (window && typeof (window as any).android !== 'undefined') {
          ;(window as any).android.payAtCashier(
            data.billing_no || data.orderId,
            this.payment,
            data.total_sales || data.totalSales,
            getEdcMidMapping()
          )
        }
        sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
        sessionStorage.setItem('orderId', data.orderId)
        let passPosResultPage = true

        VUE_APP_OTTOPAY.map(key => {
          if (Number(key) === Number(posOrderOutlet.value)) {
            passPosResultPage = false
          }
        })
        if (passPosResultPage) {
          this.orderRequestId = ''
          this.$router.push(`/pos-result`)
        }
        return
      }
      try {
        let qrCode = ''
        if (constants.QR_TYPE.includes(this.payment)) {
          if (this.payment === 'Astrapay') {
            qrCode = data.qrData.qrContent
          } else {
            qrCode =
              this.outletData.payment_method === 'Midtrans'
                ? data.qrData.qr_string
                : data.qrData.data.qrCode
          }
        }
        if (qrCode) {
          this.orderRequestId = ''
          sessionStorage.removeItem('leftTime')
          sessionStorage.setItem('payCallBackInfo', JSON.stringify(data))
          sessionStorage.setItem('orderId', data.orderId)
          sessionStorage.setItem('qrCode', qrCode)
          this.$router.push(`/pos-qr`)
        }
      } catch (error) {
        this.orderRequestId = ''
        this.$swal(
          constants.SOMETHING_WROING,
          'Please wait a few minutes before you try again.',
          constants.STATUS_ERROR
        )
      }
    })
  }
  created() {
    this.debounceCalculate = debounce(this.calculateOrder, 500)
  }
  changeDiscount(event) {
    const validateValue = this.promo_type === 0 ? 100 : Infinity
    if (isNaN(event) || Number(event) < 0 || Number(event) > validateValue) {
      return (this.promo_value = 0)
    }
    this.promo_value = event
    this.debounceCalculate()
  }
  selectDiscount(event) {
    this.promo_value = event
    this.hideDiscountChannelHandle()
    this.debounceCalculate()
    this.free_promo_value = 0
  }
  changeFreeInputPromoValue(e) {
    this.promo_value = 0
    this.free_promo_value = Number(e)
    this.debounceCalculate()
  }
  changeCustomTotalPayment(event) {
    if (isNaN(event) || Number(event) < 0) {
      return (this.custom_total_payment = 0)
    }
    this.custom_total_payment = Number(event || 0)
    this.debounceCalculate()
  }
  clickRadio(variant, item) {
    for (let i = 0; i < variant.variant_items.length; i++) {
      const variantItem = variant.variant_items[i]
      variantItem.checked = false
    }
    item.checked = true
  }
  clickCheckbox(variantIndex, variantItemIndex, cartItemIndex) {
    const cloneCartList = cloneDeep(this.cartList)
    const cloneVariantCategory =
      cloneCartList[cartItemIndex].variants[variantIndex]
    cloneVariantCategory.variant_items[
      variantItemIndex
    ].checked = !cloneVariantCategory.variant_items[variantItemIndex].checked

    const max = Number(cloneVariantCategory.max)
    const min = Number(cloneVariantCategory.min)
    const checkedList = cloneVariantCategory.variant_items.filter(
      item => item.checked
    )
    if (checkedList.length > max) {
      return this.$swal(
        constants.FAILED_MESSAGE,
        cloneVariantCategory.category_name + ' must be less than max ' + max,
        constants.STATUS_ERROR
      )
    }
    if (checkedList.length < min) {
      return this.$swal(
        constants.FAILED_MESSAGE,
        cloneVariantCategory.category_name + ' must be more than min ' + min,
        constants.STATUS_ERROR
      )
    }
    this.updateCartList(cloneCartList)
  }

  checkOrderSubmit() {
    const outletData = JSON.parse(localStorage.getItem('outletData') || '{}')
    if (outletData.pos_active === 1 && outletData.pos_order_required === 1) {
      this.showPosOrderPopup = true
    } else {
      this.submitHandle()
    }
  }

  posOrderPopup(value) {
    this.showPosOrderPopup = value
  }
  posOrderValue(value) {
    this.posOrderId = value
    this.submitHandle()
  }
}
